import type { Host, ProviderKind } from "../../api/types";
import { PROVIDER_LABEL } from "../provider-credentials/ProviderCredentialsPage";

/**
 * Shared display logic for the Hosts list/detail pair, so "how do we show
 * WHERE a host runs" is written once (charter A-5) rather than reimplemented
 * per page. `Host.provisioning.provider` is a plain `string` on the wire (not
 * the closed `ProviderKind` union) — a provider this build doesn't recognize
 * yet falls back to the server's own raw string rather than guessing at a
 * friendlier name or crashing (A-3: version skew is the normal state, never
 * an error case).
 */
export function providerLabel(provider: string): string {
  return PROVIDER_LABEL[provider as ProviderKind] ?? provider;
}

/**
 * The list/detail "WHERE" a host runs: `provider · region · serverType` for a
 * host Comebye itself provisioned, or "BYO" for one it never did
 * (`provisioning: null`) — never a row of blank provider/region/type fields
 * standing in for "we don't know" (A-10).
 */
export function formatHostWhere(host: Host): string {
  if (!host.provisioning) return "BYO";
  const { provider, region, serverType } = host.provisioning;
  return `${providerLabel(provider)} · ${region} · ${serverType}`;
}
